import React from 'react'
import './footer.css'
import { Container, Row, Col, ListGroupItem, ListGroup } from 'reactstrap'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/cclogo.png'
import tripadvisorlogo from '../../assets/images/tripadvisor.png'


const quick__links = [
  {
    path: '/home',
    display: 'Home'
  },
  {
    path: '/about',
    display: 'About'
  }, {
    path: '/tours',
    display: 'Tours'
  },
]
const quick__links2 = [
  {
    path: 'https://www.tripadvisor.ca/Attraction_Review-g294210-d12833751-Reviews-Coast_Camping_Tours_Safaris-Mombasa_Coast_Province.html',
    display: 'Trip Advisor'
  },
  {
    path: '/login',
    display: 'Login'
  }, {
    path: '/register',
    display: 'Register'
  },
]

const Footer = () => {
const year = new Date().getFullYear()

  return (
    <footer className='footer'>
      <Container>
        <Row>
          <Col lg='3'>
          <div className="logo">
          <img src={logo} alt="" />
            <p>Explore the beauty of Kenya with Coast Camping Tours and Safaris – Your adventure begins here.</p>
            <div className="social__links d-flex align-items-center gap-4">
              <span>
                <Link to='#'><i class='ri-youtube-line'></i></Link>
              </span>
              <span>
              <a href='https://www.tripadvisor.ca/Attraction_Review-g294210-d12833751-Reviews-Coast_Camping_Tours_Safaris-Mombasa_Coast_Province.html'><img src={tripadvisorlogo} alt="" /></a>
              </span>
              <span>
                <a href='https://www.facebook.com/share/1Hj6caNvy2/?mibextid=wwXIfr'><i class='ri-facebook-circle-line'></i></a>
              </span>
              <span>
                <a href='https://www.instagram.com/coastcamping/profilecard/?igsh=M2hsbjJoZzk4ZzY5'><i class='ri-instagram-line'></i></a>
              </span>
            </div>
          </div>
           
          </Col>

          <Col lg='3'>
            <h5 className="footer__link-title">Discover</h5>
            <ListGroup className='footer__quick-links'>
              {
                quick__links.map((item, index) => (
                  <ListGroupItem key={index} className='ps-0 border-0'>
                    <Link to={item.path}> {item.display}</Link>
                  </ListGroupItem>
                ))
              }
            </ListGroup>
          </Col>
          <Col lg='3'>
          <h5 className="footer__link-title">Quick Links</h5>
            <ListGroup className='footer__quick-links'>
              {
                quick__links2.map((item, index) => (
                  <ListGroupItem key={index} className='ps-0 border-0'>
                    <a href={item.path}> {item.display}</a>
                  </ListGroupItem>
                ))
              }
            </ListGroup>
          </Col>
          <Col lg='3'>
          <h5 className="footer__link-title">Contact</h5>
            <ListGroup className='footer__quick-links'>
              
                  <ListGroupItem className='ps-0 border-0 d-flex align-items-center gap-3'>
                    <h6 className='mb-0 d-flex align-items-center gap-2'>
                      <span><i class='ri-map-pin-line'></i></span>
                      Address:
                      </h6>
                      <p className='mb-0'>Mombasa, Kenya</p>
                    
                  </ListGroupItem>       
              
              <ListGroupItem className='ps-0 border-0 d-flex align-items-center gap-3'>
                <h6 className='mb-0 d-flex align-items-center gap-2'>
                  <span><i class='ri-mail-line'></i></span>
                  Email:
                  </h6>
                  <p className='mb-0'>coastcampingtours@gmail.com</p>
                
              </ListGroupItem>

              <ListGroupItem className='ps-0 border-0 d-flex align-items-center gap-3'>
                <h6 className='mb-0 d-flex align-items-center gap-2'>
                  <span><i class='ri-phone-fill'></i></span>
                  Phone:
                  </h6>
                  <p className='mb-0'>+2547 55 555 115</p>
                
                  </ListGroupItem>
          
        </ListGroup>
            </Col>
            <Col lg='12' className='text-center pt-5'>
            <p className='copyright'>Copyright {year}, design and developed by <a href="https://alphawebske.netlify.app/">AlphaWebs KE</a> All rights reserved</p>
            </Col>
        </Row>
      </Container>

    </footer>
  )
}

export default Footer
